import { Component, inject } from '@angular/core';
import { UsersHttpService } from '../../../../core/state/users/users-http.service';
import { UserDataService } from '../../state-and-data-handling/user-data.service';

@Component({
  selector: 'app-user-profile-data',
  templateUrl: './user-profile-data.component.html',
  styleUrl: './user-profile-data.component.scss',
  standalone: false,
})
export class UserProfileDataComponent {
  private readonly usersHttpService = inject(UsersHttpService);
  private readonly userDataService = inject(UserDataService);

  public cancel(): void {}

  public onSubmit(): void {
    const user = this.userDataService.getUserClone()!;
    this.usersHttpService.updateUser(user);
  }
}
